import * as OFMSUI from "react-bootstrap"; import "bootstrap/dist/css/bootstrap.min.css"; import { useFormik, FormikProvider, Field } from "formik"; import React, { useState } from "react";
import HousingService from "../../../Services/HousingService"; import NavigationServicesHeader from "../../../Header/NavigationServicesHeader";
import { DashboardServiceReport, ExportToExcelButton, formatIndianNumber, formatINR, generatePDF, LabelHeader, ModuleHeaderTitle, todayDate } from "../../utils/commonFunctions"; import { store } from "../../../App"; import ShowAlert from "../../alert";
import { Form, Table } from "react-bootstrap"; import { Link } from "@mui/material"; import styled from "styled-components"; import ReactHTMLTableToExcel from "react-html-table-to-excel"; import { useHistory } from "react-router-dom/cjs/react-router-dom";
import * as Yup from "yup";
import moment from "moment-timezone";
import { MdOutlinePictureAsPdf } from "react-icons/md";
import { AiOutlineSearch } from "react-icons/ai";

const ProfitandLoss = () => {
  const [netData, setNetData] = useState([]);
  const [showParticularsTable, setShowParticularsTable] = useState(false);
  const [showHeadsTable, setShowHeadsTable] = useState(false);
  const [subHeadsData, setSubheadsData] = useState([]);
  const [subtitle, setSubtitle] = useState("");
  const [savenote, setSaveNote] = useState("");
  const [districtListPl, setDistrictListPl] = useState([]);
  const history = useHistory(); const [saveFromdate, setSaveFromdate] = useState(""); const [saveTodate, setSaveTodate] = useState(""); const [search, setSearch] = useState("");

  React.useEffect(() => {
    HousingService.CGG_District().then((res) => {
      if (res.data) {
        let options = res.data.map((item, i) => { return (<option key={i} value={item.code}> {item.name} </option>); }); setDistrictListPl(options);
      }
    });

    // const fetchApiData = async () => {
    //   store.dispatch({ type: "SHOW_SPINNER" });
    //   const params = { "type": 'PL' };
    //   try {
    //     const [resOB, resNet] = await Promise.all([HousingService.BalanceSheetNotenoDataOB(params), HousingService.BalanceSheetNotenoDataNet(params)]);
    //     if (resOB?.data?.length > 0) { setOBdata(resOB.data); } if (resNet?.data?.length > 0) { setNetData(resNet.data); }
    //   }
    //   catch (error) { console.log("error", error) }
    //   finally { store.dispatch({ type: "HIDE_SPINNER" }); setShowParticularsTable(true); setShowHeadsTable(false); }
    // };
    // fetchApiData();

  }, []);

  const validationSchema = Yup.object().shape({
    fromDate: Yup.date().required("required"),
    toDate: Yup.date().required("required"),
    // district: Yup.string().required("district is required"),
  });

  const formik1 = useFormik({
    initialValues: {
      fromDate: "",
      toDate: "",
      district: "0",

    },
    validationSchema: validationSchema,
    onSubmit: (values) => {
      console.log(values);
      setSaveTodate(values.toDate);
      setSaveFromdate(values.fromDate);
      fetchDataPl(values.fromDate, values.toDate, values.district);
    }
  })

  const fetchDataPl = async (fromDate, toDate, district) => {
    store.dispatch({ type: "SHOW_SPINNER" });

    const params = { "fromDate": moment(fromDate).format("DD-MM-YYYY"), "toDate": moment(toDate).format("DD-MM-YYYY"), "security_id": district };
    // const params2 = { type: "PL", "toDate": moment(toDate).format("DD-MM-YYYY"), "security_id": district };

    try {
      const [resplNet] = await Promise.all([
        // const [resplOB, resplNet] = await Promise.all([
        HousingService.ProfitandLossStatment(params)
        // ,HousingService.BalanceSheetNotenoDataNet(params2)
      ]);

      // if (resplOB?.data?.length > 0) {
      //   console.log(resplOB.data);
      //   setOBdata(resplOB.data);
      // }
      // else {
      //   setOBdata([]);
      // }
      if (resplNet?.data?.length > 0) {
        console.log(resplNet.data);
        setNetData(resplNet.data);
      }
      else {
        setNetData([]);
      }

    } catch (error) {
      console.error("Error fetching balance sheet data:", error);
    } finally {
      setShowParticularsTable(true);
      setShowHeadsTable(false);
      store.dispatch({ type: "HIDE_SPINNER" });
    }
  };

  const headidClick = (noteno, title) => {
    setSaveNote(noteno);
    setSubtitle(title);
    store.dispatch({ type: "SHOW_SPINNER" });
    const params = { "noteno": noteno, "fromDate": moment(formik1.values.fromDate).format("DD-MM-YYYY"), "toDate": moment(formik1.values.toDate).format("DD-MM-YYYY"), "security_id": formik1.values.district };

    HousingService.ProfitandLossStatmentPeriodforNoteno(params).then((res) => {
      if (res && res.data && res.data?.length > 0) { console.log(res.data); setSubheadsData(res.data) } else { setSubheadsData([]) }
    }).catch((error) => {
      ShowAlert("Some error occurred", "error"); console.log(error);
    }).finally(() => { setShowParticularsTable(false); setShowHeadsTable(true); store.dispatch({ type: "HIDE_SPINNER" }); });;

  }


  const filteredData = search.length > 0 ? subHeadsData?.filter((item) => {
    return (
      item && Object.keys(item).some((key) => {
        const value = item[key];
        return (
          value !== null && value.toString().toLowerCase().includes(search.toLowerCase()));
      }));
  }) : subHeadsData;

  const ProfitandLossback = () => { if (showHeadsTable) { setShowHeadsTable(false); setShowParticularsTable(true); } else { history.goBack(); } }


  const getProfitandLossPdf = () => {
    let type = 'PL';
    HousingService.ProfitandLossPDF(type).then((res) => { const url = window.URL.createObjectURL(new Blob([res.data], { type: "application/pdf" })); let tab = window.open(); tab.location.href = url; });
  };


  const handleSearch = event => { setSearch(event.target.value) }
  return (
    <>
      <NavigationServicesHeader />
      <OFMSUI.Container fluid style={{ width: "65%" }}> <OFMSUI.Row> <ModuleHeaderTitle title="Statement of Profit and Loss Account" /> <OFMSUI.Col xs={12} sm={12} md={12} lg={6} xl={6} xxl={6} className="page-titlespacing" >
        <button className="btn btn-primary" style={{ textAlign: "right", float: "right", marginTop: "30px" }} type="button" onClick={() => ProfitandLossback()} > Back </button> </OFMSUI.Col> </OFMSUI.Row> </OFMSUI.Container>
      <OFMSUI.Container className="outer-page-content-container" fluid style={{ width: "65%" }}>
        <FormikProvider value={formik1}> <Form onSubmit={formik1.handleSubmit}>
          <DashboardServiceReport title="Report" />
          <OFMSUI.Row>
            <OFMSUI.Col xs={12} sm={12} md={12} lg={2} xl={2} xxl={2}>
              <LabelHeader title="From Date" />
              <Field name="fromDate" className={formik1.touched.fromDate && formik1.errors.fromDate ? "form-control is-invalid" : "form-control"} type="date" onChange={(e) => formik1.handleChange(e)}
                // min="2022-04-01"
                max={todayDate}
              />
              {formik1.touched.fromDate && formik1.errors.fromDate ? (<div className="invalid-feedback"> {formik1.errors.fromDate} </div>) : null} </OFMSUI.Col>
            <OFMSUI.Col xs={12} sm={12} md={12} lg={2} xl={2} xxl={2}>
              <LabelHeader title="To Date" />
              <Field name="toDate" className={formik1.touched.toDate && formik1.errors.toDate ? "form-control is-invalid" : "form-control"} type="date"
                min={formik1.values.fromDate}
                max={todayDate} onChange={(e) => formik1.handleChange(e)} /> {formik1.touched.toDate && formik1.errors.toDate ? (<div className="invalid-feedback">{formik1.errors.toDate}</div>) : null} </OFMSUI.Col>
            <OFMSUI.Col xs={12} sm={12} md={12} lg={2} xl={2} xxl={2}>
              <LabelHeader title=" District" />
              <Field component="select"
                name="district" className={formik1.touched.district && formik1.errors.district ? "form-control is-invalid" : "form-control"}
                onChange={(e) => formik1.handleChange(e)} > {formik1.touched.district && formik1.errors.district ? (<div className="invalid-feedback"> {formik1.errors.district} </div>) : null}
                <option value="0">State</option>
                {districtListPl}
              </Field> </OFMSUI.Col>
            <OFMSUI.Col xs={12} sm={12} md={12} lg={2} xl={2} xxl={2} className="mb-3">
              <div className="d-grid mt-2">
                <button type="submit" className="btn btn-success btn-sm mt-3">
                  Get Details
                </button>
              </div>
            </OFMSUI.Col>
          </OFMSUI.Row>
          {showParticularsTable && (
            <>
              {/* <div> <OFMSUI.Row className="mb-2"> <OFMSUI.Col xs={12}> <div style={{ display: "flex", justifyContent: "flex-end" }}> <button className="btn btn-warning btn-sm" onClick={() => getProfitandLossPdf()} type="button" > Print </button> </div> </OFMSUI.Col> </OFMSUI.Row> </div> */}
                            <div style={{justifyContent:"center",alignContent:"center",marginTop:"20px"}}> <h5 style={{ textAlign: "center" }}> Statement of Profit and Loss Account  between {moment(saveFromdate).format("Do MMMM YYYY")} and {moment(saveTodate).format("Do MMMM YYYY")}</h5> </div>
              <div style={{ overflow: "auto" }}>
                <Table bordered>
                  <thead className="fw-bold" style={{ position: "sticky", top: "0px" }} > <tr style={{ textAlign: "center" }} className="table_countshead">
                    <th>S. No.</th> <th style={{ textAlign: "left" }}>Particulars</th>
                    <th>Note No.</th>
                    <th>For the year ended {moment(saveTodate).format("Do MMMM YYYY")}</th>
                  </tr> </thead>
                  <tbody>
                    <tr style={{ textAlign: "center" }}> <td>1</td> <td style={{ textAlign: "left" }}>Revenue from operations</td> <td
                      onClick={() => headidClick("16", "Revenue from operations")}
                    >
                      <Link style={{ textDecoration: "none", cursor: "pointer" }}>16</Link>
                    </td>
                      <td className="text-right">{Math.abs(netData.find((items) => items.noteno === "16")?.finalvalue ?? 0).toLocaleString("en-IN")}</td>
                    </tr>
                    <tr style={{ textAlign: "center" }}> <td>2</td>
                      <td style={{ textAlign: "left" }}>Other Income</td> <td
                        onClick={() => headidClick("17", "Other Income")}
                      >
                        <Link style={{ textDecoration: "none", cursor: "pointer" }}>17</Link>
                      </td>
                      <td className="text-right">{Math.abs(netData.find((items) => items.noteno === "17")?.finalvalue ?? 0).toLocaleString("en-IN")}</td>
                    </tr>
                    <tr style={{ textAlign: "center" }}>
                      <td>3</td> <td style={{ textAlign: "left", backgroundColor: "#FFFAFA" }}> <b>Total Revenue (1+2) </b> </td> <td style={{ backgroundColor: "#FFFAFA" }}></td>
                      <td className="text-right" style={{ backgroundColor: "#FFFAFA" }}>
                        <b style={{ color: "green" }}>{(Math.abs(netData.find(items => items.noteno === "16")?.finalvalue ?? 0) + Math.abs(netData.find(items => items.noteno === "17")?.finalvalue ?? 0)).toLocaleString("en-IN")} </b></td>
                    </tr>
                    <tr style={{ textAlign: "center" }}>
                      <td rowSpan={7}>4</td> <td style={{ textAlign: "left" }}>Expenses</td> <td></td> <td></td>
                      {/* <td></td> */}
                    </tr>
                    <tr style={{ textAlign: "center" }}> <td style={{ textAlign: "left" }}>(a) Employee benefits expenses</td>
                      <td
                        onClick={() => headidClick("18", "Employee benefits expenses")}
                      >
                        <Link style={{ textDecoration: "none", cursor: "pointer" }}>18</Link>
                      </td>
                      <td className="text-right">{Math.abs(netData.find((items) => items.noteno === "18")?.finalvalue ?? 0).toLocaleString("en-IN")}</td>
                    </tr>
                    <tr style={{ textAlign: "center" }}> <td style={{ textAlign: "left" }}>(b) Administrative expenses</td>
                      <td
                        onClick={() => headidClick("19", "Administrative expenses")}
                      >
                        <Link style={{ textDecoration: "none", cursor: "pointer" }}>19</Link>
                      </td>
                      <td className="text-right">{Math.abs(netData.find((items) => items.noteno === "19")?.finalvalue ?? 0).toLocaleString("en-IN")}</td>
                    </tr>
                    <tr style={{ textAlign: "center" }}> <td style={{ textAlign: "left" }}>(c) Finance costs</td>
                      <td
                        onClick={() => headidClick("20", "Finance costs")}
                      >
                        <Link style={{ textDecoration: "none", cursor: "pointer" }}>20</Link>
                      </td>
                      <td className="text-right">{Math.abs(netData.find((items) => items.noteno === "20")?.finalvalue ?? 0).toLocaleString("en-IN")}</td>
                    </tr>

                    <tr style={{ textAlign: "center" }}> <td style={{ textAlign: "left" }}>(d) Depreciation and amortisation expenses</td>
                      <td
                        onClick={() => headidClick("9", "Depreciation and amortisation expenses")}
                      >
                        <Link style={{ textDecoration: "none", cursor: "pointer" }}>9</Link>
                      </td>
                      <td className="text-right">{Math.abs(netData.find((items) => items.noteno === "9")?.finalvalue ?? 0).toLocaleString("en-IN")}</td>
                    </tr>

                    <tr style={{ textAlign: "center" }}> <td style={{ textAlign: "left" }}>(e) Other expenses</td>
                      <td
                        onClick={() => headidClick("21", "Other expenses")}
                      >
                        <Link style={{ textDecoration: "none", cursor: "pointer" }}>21</Link>
                      </td>
                      <td className="text-right">{Math.abs(netData.find((items) => items.noteno === "21")?.finalvalue ?? 0).toLocaleString("en-IN")}</td>
                    </tr>

                    <tr style={{ textAlign: "center", backgroundColor: "#FFFAFA" }}> <td style={{ textAlign: "left" }}> <b>Total Expenses</b></td> <td></td>

                      <td className="text-right"> <b style={{ color: "red" }}> {(Math.abs(netData.find((items) => items.noteno === "18")?.finalvalue ?? 0) + Math.abs(netData.find((items) => items.noteno === "19")?.finalvalue ?? 0) + Math.abs(netData.find((items) => items.noteno === "20")?.finalvalue ?? 0) + Math.abs(netData.find((items) => items.noteno === "9")?.finalvalue ?? 0) + Math.abs(netData.find((items) => items.noteno === "21")?.finalvalue ?? 0)).toLocaleString("en-IN")} </b> </td>
                    </tr>
                    <tr style={{ textAlign: "center" }}>
                      <td>5</td> <td style={{ textAlign: "left" }}>Profit / (Loss) before exceptional & extraordinary itemss and tax (3 - 4) </td> <td></td>

                      <td className="text-right"> {formatIndianNumber(Math.abs(netData.find(items => items.noteno === "16")?.finalvalue ?? 0) + Math.abs(netData.find(items => items.noteno === "17")?.finalvalue ?? 0) - (Math.abs(netData.find(items => items.noteno === "18")?.finalvalue ?? 0) + Math.abs(netData.find(items => items.noteno === "19")?.finalvalue ?? 0) + Math.abs(netData.find(items => items.noteno === "20")?.finalvalue ?? 0) + Math.abs(netData.find(items => items.noteno === "9")?.finalvalue ?? 0) + Math.abs(netData.find(items => items.noteno === "21")?.finalvalue ?? 0)))} </td>



                    </tr>
                    <tr style={{ textAlign: "center" }}> <td>6</td> <td style={{ textAlign: "left" }}>Exceptional Items </td> <td>-</td> <td className="text-right">-</td>
                    </tr>
                    <tr style={{ textAlign: "center" }}>
                      <td>7</td> <td style={{ textAlign: "left" }}>Profit / (Loss) before exceptional items and tax (5 - 6) </td> <td></td>

                      <td className="text-right"> {formatIndianNumber(Math.abs(netData.find(items => items.noteno === "16")?.finalvalue ?? 0) + Math.abs(netData.find(items => items.noteno === "17")?.finalvalue ?? 0) - (Math.abs(netData.find(items => items.noteno === "18")?.finalvalue ?? 0) + Math.abs(netData.find(items => items.noteno === "19")?.finalvalue ?? 0) + Math.abs(netData.find(items => items.noteno === "20")?.finalvalue ?? 0) + Math.abs(netData.find(items => items.noteno === "9")?.finalvalue ?? 0) + Math.abs(netData.find(items => items.noteno === "21")?.finalvalue ?? 0)))} </td>
                    </tr>
                    <tr style={{ textAlign: "center" }}>
                      <td>8</td>
                      <td style={{ textAlign: "left" }}>Extra Ordinary Items </td>
                      <td
                        onClick={() => headidClick("22", "Extra Ordinary Items")}
                      >
                        <Link style={{ textDecoration: "none", cursor: "pointer" }}>22</Link>
                      </td>
                      <td className="text-right">{Math.abs(netData.find((items) => items.noteno === "22")?.finalvalue ?? 0).toLocaleString("en-IN")}</td>
                    </tr>
                    <tr style={{ textAlign: "center" }}>
                      <td>9</td> <td style={{ textAlign: "left" }}> Profit Before Tax (7 - 8) </td> <td></td>

                      <td className="text-right"> {formatIndianNumber(Math.abs(netData.find(items => items.noteno === "16")?.finalvalue ?? 0) + Math.abs(netData.find(items => items.noteno === "17")?.finalvalue ?? 0) - (Math.abs(netData.find(items => items.noteno === "18")?.finalvalue ?? 0) + Math.abs(netData.find(items => items.noteno === "19")?.finalvalue ?? 0) + Math.abs(netData.find(items => items.noteno === "20")?.finalvalue ?? 0) + Math.abs(netData.find(items => items.noteno === "9")?.finalvalue ?? 0) + Math.abs(netData.find(items => items.noteno === "21")?.finalvalue ?? 0)) - Math.abs(netData.find(items => items.noteno === "22")?.finalvalue ?? 0))} </td>
                    </tr>
                    <tr style={{ textAlign: "center" }}> <td rowSpan={6}>10</td> <td style={{ textAlign: "left" }}>Tax Expense :</td> <td></td> <td className="text-right">-</td>
                    </tr>
                    <tr style={{ textAlign: "center" }}> <td style={{ textAlign: "left" }}> (a) Current tax expense</td> <td></td> <td className="text-right">-</td>
                    </tr>
                    <tr style={{ textAlign: "center" }}> <td style={{ textAlign: "left" }}> (b) (Less) : MAT credit (where applicable)</td> <td></td> <td className="text-right">-</td>
                    </tr>
                    <tr style={{ textAlign: "center" }}> <td style={{ textAlign: "left" }}>(c) Current tax expense relating to prior years</td> <td></td> <td className="text-right">-</td>
                    </tr>
                    <tr style={{ textAlign: "center" }}> <td style={{ textAlign: "left" }}>(d) Net current tax expense</td> <td></td> <td className="text-right">-</td>
                    </tr>
                    <tr style={{ textAlign: "center" }}> <td style={{ textAlign: "left" }}>(e) Deferred tax</td> <td></td>
                      <td className="text-right">-</td>
                    </tr>
                    <tr style={{ textAlign: "center" }}>
                      <td>11</td> <td style={{ textAlign: "left" }}>  Profit / (Loss) from continuing operations (9 - 10) </td> <td></td>

                      <td className="text-right"> {formatIndianNumber(Math.abs(netData.find(items => items.noteno === "16")?.finalvalue ?? 0) + Math.abs(netData.find(items => items.noteno === "17")?.finalvalue ?? 0) - (Math.abs(netData.find(items => items.noteno === "18")?.finalvalue ?? 0) + Math.abs(netData.find(items => items.noteno === "19")?.finalvalue ?? 0) + Math.abs(netData.find(items => items.noteno === "20")?.finalvalue ?? 0) + Math.abs(netData.find(items => items.noteno === "9")?.finalvalue ?? 0) + Math.abs(netData.find(items => items.noteno === "21")?.finalvalue ?? 0)) - Math.abs(netData.find(items => items.noteno === "22")?.finalvalue ?? 0))} </td>
                    </tr>
                    <tr style={{ textAlign: "center" }}> <td>12</td> <td style={{ textAlign: "left" }}> Profit / (Loss) from discontinuing operations </td> <td></td> <td className="text-right">-</td>
                    </tr>
                    <tr style={{ textAlign: "center" }}> <td>13</td> <td style={{ textAlign: "left" }}> Tax Expenses of discontinuing operations</td> <td></td> <td className="text-right">-</td>
                    </tr>
                    <tr style={{ textAlign: "center" }}> <td>14</td> <td style={{ textAlign: "left" }}>Profit / (Loss) from discontinuing operations (after Tax) (12 - 13) </td> <td></td>
                      <td className="text-right">-</td>
                    </tr>
                    <tr style={{ textAlign: "center" }}>
                      <td>15</td>
                      <td style={{ textAlign: "left", backgroundColor: "#FFFAFA" }}>  Profit / (Loss) for the Period (11+14)</td>
                      <td style={{ backgroundColor: "#FFFAFA" }}></td>

                      <td className="text-right" style={{ backgroundColor: "#FFFAFA" }} >
                        <b style={{ color: "seablue" }}>
                          {formatIndianNumber(Math.abs(netData.find(items => items.noteno === "16")?.finalvalue ?? 0) + Math.abs(netData.find(items => items.noteno === "17")?.finalvalue ?? 0) - (Math.abs(netData.find(items => items.noteno === "18")?.finalvalue ?? 0) + Math.abs(netData.find(items => items.noteno === "19")?.finalvalue ?? 0) + Math.abs(netData.find(items => items.noteno === "20")?.finalvalue ?? 0) + Math.abs(netData.find(items => items.noteno === "9")?.finalvalue ?? 0) + Math.abs(netData.find(items => items.noteno === "21")?.finalvalue ?? 0)) - Math.abs(netData.find(items => items.noteno === "22")?.finalvalue ?? 0))}
                        </b>
                      </td>
                    </tr>
                    <tr style={{ textAlign: "center" }}> <td rowSpan={2}>16</td>
                      <td style={{ textAlign: "left" }}> Earning per equity share : </td>
                      <td></td> <td></td>
                    </tr>
                    <tr style={{ textAlign: "center" }}>
                      <td style={{ textAlign: "left" }}>(1) Basic </td>
                      <td></td>
                      <td className="text-right">(661,468)</td>
                    </tr>
                    <tr style={{ textAlign: "center" }}>
                      <td></td>
                      <td style={{ textAlign: "left" }}>(2) Diluted </td>
                      <td></td>
                      <td className="text-right">(661,468)</td>
                    </tr>
                  </tbody>
                </Table>
              </div>
            </>)}






          {showHeadsTable && (
            <>
              <div style={{justifyContent:"center",alignContent:"center",marginTop:"20px"}}>
                <h5 style={{ textAlign: "center" }}>
                  Statement of Profit and Loss Account between {moment(saveFromdate).format("Do MMMM YYYY")} and {moment(saveTodate).format("Do MMMM YYYY")}
                </h5>
              </div>
              <OFMSUI.Row>
                <OFMSUI.Col xs={12} sm={12} md={3} lg={3} xl={3} xxl={3} className=' mb-3' > <div className='input-group'> <div className='input-group-prepend'> <div className='input-group-text group_txt11' id='btnGroupAddon' > <AiOutlineSearch /> </div> </div> <input type='text' id='#filterInput' placeholder='Search ' style={{ width: '25%' }}
                  className='form-control input-lg' value={search} onChange={handleSearch} ></input> </div> </OFMSUI.Col>
                <OFMSUI.Col xs={12} sm={12} md={12} lg={9} xl={9} xxl={9} className=' mb-3 float-end' >
                  <ExportToExcelButton tableId="my-table4" filename="ProfitandLoss" sheet="tablexls" buttonText="Excel" />
                  <button className='btn btn-danger btn-sm' type='button' style={{ float: 'right', marginLeft: '3px' }}
                    onClick={() => generatePDF("my-table4", "Profit an dLoss", "ProfitandLoss.pdf", 5)}> PDF <MdOutlinePictureAsPdf /> </button>
                </OFMSUI.Col>
              </OFMSUI.Row>
              <div style={{ overflow: "auto",height:"600px" }}>
                <Table id="my-table4" fluid>
                  <thead className="fw-bold" style={{ position: "sticky", top: "0px", zIndex: 1 }}>
                    <tr> <th style={{ textAlign: "left", backgroundColor: "#ECF3F9" }} colSpan={4}> Note No {savenote} : {subtitle.toUpperCase()} </th> </tr>
                    <tr className="table_countshead">
                      <th className="text-center">S.No.</th>
                      <th>Head ID</th>
                      <th>Head name</th>
                      <th className="text-center"> For the year ended {moment(saveTodate).format("Do MMMM YYYY")} </th>
                    </tr>
                  </thead>
                  <tbody>
                    {!filteredData || filteredData.length === 0 ? (
                      <tr> <td colSpan={4} style={{ textAlign: "center" }}> No Data found </td> </tr>
                    ) : (
                      filteredData.map((item, index) => (
                        <tr key={index}>
                          <td className="text-center">{index + 1}</td> <td>{item.headid}</td> <td>{item.headname}</td> <td className="text-right"> {formatIndianNumber(item.netvalue)} </td>
                        </tr>
                      ))
                    )}
                  </tbody>
                  <tfoot>
                    <tr className="table_countshead"> <td colSpan={3} style={{ textAlign: "right" }}>Total Amount in Rs/-</td> <td className="text-right"> {formatIndianNumber(filteredData?.reduce((a, b) => a + (b?.netvalue || 0), 0))} </td> </tr>
                  </tfoot>
                </Table>
              </div>
            </>
          )}


        </Form>
        </FormikProvider>
      </OFMSUI.Container>

    </>
  )
}

export default ProfitandLoss
